import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-shared-card',
  templateUrl: './shared-card.component.html',
  styleUrls: ['./shared-card.component.css']
})
export class SharedCardComponent implements OnInit {
  @Input() showDate: any;

  constructor() { }

  ngOnInit(): void {

    setTimeout(() => {
      console.log(this.showDate)
    }, 500)
  }

}
